module.exports = __webpack_public_path__ + "img/expense_category_activities.b4caade.png";